import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';

import { fetchTranslations } from '@/lib/api';
import { useSiteBootstrap } from '@/lib/contexts/SiteBootstrapProvider';

type KeyValueList<T> = Record<string, T>;

export const useCurrentTranslations = () => {
  const locale = useLocale();
  const { tenantId } = useSiteBootstrap(); // string | null

  return useQuery<KeyValueList<string>>({
    queryKey: ['translations', tenantId ?? null, locale],
    queryFn: () => fetchTranslations(locale),
    staleTime: Infinity,
  });
};
